"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Fin = require("finnlp");
const en_inflectors_1 = require("en-inflectors");
const tag_tense_1 = require("./tag_tense");
const rules_1 = require("./rules");
Fin.Run.prototype.tense = function () {
    const tenses = [];
    this.sentences.forEach((sentence, sentenceIndex) => {
        const rootIndex = sentence.deps.findIndex(node => node.parent === -1);
        const rootTense = tag_tense_1.tagTense[sentence.tags[rootIndex]];
        const auxes = [];
        for (var index = 0; index < sentence.deps.length; index++) {
            var node = sentence.deps[index];
            if (node.parent !== rootIndex)
                continue;
            if (node.label.startsWith("AUX")) {
                auxes.push({
                    base: new en_inflectors_1.Inflectors(sentence.tokens[index]).toPresent(),
                    tense: tag_tense_1.tagTense[sentence.tags[index]],
                });
            }
        }
        const applicableRule = rules_1.rules.find((rule) => rule.auxNo === auxes.length &&
            rule.rootTense === rootTense &&
            rule.auxBases.join("") === auxes.map(x => x.base).join("") &&
            rule.auxTenses.join("") === auxes.map(x => x.tense).join(""));
        if (applicableRule)
            tenses.push(applicableRule.tense);
    });
    return tenses;
};
